export function CloudMark() {
  return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path fill="#2858de" d="M8 25C3.6 25 1 22.4 1 18.8C1 15.3 3.3 12.8 6.7 12.3C7.8 6.5 12.4 3.5 17.4 4.4C21.5 5.1 24.6 8.2 25.3 12.4C29 12.8 31 15.3 31 18.7C31 22.4 28.4 25 24 25Z"/>
    <path stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M20 10.5H14.4C10.9 10.5 10.9 15.4 14.4 15.4H17.6C21.1 15.4 21.1 20.5 17.6 20.5H12"/>
  </svg>
}
